import { render, staticRenderFns } from "./CouponItem.vue?vue&type=template&id=0ea32286&scoped=true"
import script from "./CouponItem.vue?vue&type=script&lang=ts"
export * from "./CouponItem.vue?vue&type=script&lang=ts"
import style0 from "./CouponItem.vue?vue&type=style&index=0&id=0ea32286&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea32286",
  null
  
)

export default component.exports